import React from "react";
import Modal from '../components/Modal'
import { checkTranslation, translate } from "../utils/useful";
import ButtonAnimated from "../components/buttons/ButtonAnimated";


class RemoveConfirmationModal extends React.Component {
    state = {
    }

    componentDidMount() {
    }




    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={450}>
                <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                    <div className="p-4">
                        <p className="text-normal weight-600 pb-3" style={{}}>{checkTranslation(this.props.description) ?? translate('Are you sure you want to remove this record?')}</p>
                        <p className="text-small weight-500 main-c7" style={{}}>{translate('This action cannot undone. All values associated with this field will be lost.')}</p>
                        <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                            <div className="flexc mrd-2">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.modal.hideModal() }}
                                    title={translate('Cancel')}
                                    textColor={'#a3a2b0'}
                                    bg={'#eee'}
                                />
                            </div>
                            <div className="flexc mld-2">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    isLoading={this.props.isLoading}
                                    onClick={() => { if (this.props.confirmed) this.props.confirmed() }}
                                    title={translate('Remove')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={'#fff'}
                                    bg={'#c83418'}
                                />
                            </div>
                        </div>
                        {/* <button onClick={() => { if (this.props.confirmed) this.props.confirmed() }} className="py-2 px-1 w-100 flexc" style={{ borderBottom: '1px solid #eee' }}>
                            <img className="mrd-3" src="/assets/icons/useful/remove-g.svg" width="20px" />
                            <p className="text-normal ">{translate('Remove')}</p>
                        </button>


                        <button onClick={() => this.modal.hideModal()} className="py-2 w-100 flexc px-1" style={{ borderBottom: '0px solid #eee' }}>
                            <img className="mrd-3" src="/assets/icons/useful/cancel-g.svg" width="20px" />
                            <p className="text-normal ">{translate('Cancel')}</p>
                        </button> */}


                    </div>
                </div>
            </Modal>
        );

    }
}


export default RemoveConfirmationModal;
